module.exports = __webpack_public_path__ + "static/img/logo.739e522b.jpg";